<div>
  @if (device.online && device.ownerLoggedIn) {
    <img class="wifi-user" src="assets/images/wifi-user.svg" />
  } @else {
    <i  class="fas fa-wifi" [ngClass]="device.online ? 'online' : 'offline'"></i>
  }
</div>